import React from 'react'
import { DateTime } from 'luxon'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import PaymentOutlinedIcon from 'components/material-symbol/icons/Payment'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  participantRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 0,
    marginBottom: theme.spacing(2),
  },
  participantIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: '#E0EAFF',
    marginRight: theme.spacing(2),
    flexShrink: 0,
  },
  participantIconGlyph: {
    color: '#001C57',
  },
  participantName: {
    fontWeight: 600,
    color: '#172024',
  },
  participantMeta: {
    color: theme.palette.text.secondary,
  },
  divider: {
    marginBottom: theme.spacing(3),
  },
}))

const RecordBookingPaymentParticipantSummary = ({
  participantName,
  eventTitle,
  eventDate,
  showDivider = true,
  dividerClassName,
}) => {
  const classes = useStyles()
  const dividerClasses = dividerClassName || classes.divider

  return (
    <>
      <Box className={classes.participantRow}>
        <Box className={classes.participantIcon}>
          <PaymentOutlinedIcon className={classes.participantIconGlyph} />
        </Box>
        <Box minWidth={0}>
          <Typography variant="subtitle1" className={classes.participantName}>
            {participantName}
          </Typography>
          <Typography variant="body2" className={classes.participantMeta}>
            {eventTitle} • {DateTime.fromISO(eventDate).toFormat('DD')}
          </Typography>
        </Box>
      </Box>
      {showDivider ? <Divider className={dividerClasses} /> : null}
    </>
  )
}

export default RecordBookingPaymentParticipantSummary
